import { Model } from '@vuex-orm/core'
import Ltm from '@models/helpers/Ltm'
import LtmHasRoomtype from '@models/helpers/LtmHasRoomtype'
import LtmHasRoomtypeHasRoomltm from '@models/helpers/LtmHasRoomtypeHasRoomltm'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'

export default class Roomtype extends Model{
  static entity = 'roomtypes'
  static fields () {
    return {
      id: this.number(null),
      active: this.number(null).nullable(),
      air_type: this.number(null).nullable(),
      air_volume_red_with_window: this.number(null).nullable(),
      air_volume_red_without_window: this.number(null).nullable(),
      au_volume_insulation_high: this.number(null).nullable(),
      au_volume_insulation_low: this.number(null).nullable(),
      default_window: this.number(null).nullable(),
      door_width: this.number(null).nullable(),
      edit_window: this.boolean(null).nullable(),
      f_zu: this.number(null).nullable(),
      f_zu_max_delta: this.number(null).nullable(),
      label: this.string(null).nullable(),
      roomprio: this.number(null).nullable(),
      sort: this.number(null).nullable(),

      ltms: this.hasMany(LtmHasRoomtype, 'roomtypes_id'),
      ltmHasRoomtypeHasRoomltms: this.hasMany(LtmHasRoomtypeHasRoomltm, '​​​​roomtypes_id'),
      roomtypesHasOperationmodesHasAirvolumes: this.hasMany(RoomtypesHasOperationmodesHasAirvolume, 'roomtypes_id'),
    }
  }
}
  